import { render } from "./ScrollTopArrow.vue?vue&type=template&id=159e12a6&scoped=true"
import script from "./ScrollTopArrow.vue?vue&type=script&lang=js"
export * from "./ScrollTopArrow.vue?vue&type=script&lang=js"

import "./ScrollTopArrow.vue?vue&type=style&index=0&id=159e12a6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-159e12a6"]])

export default __exports__